import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, DollarSignIcon, AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-20 px-4 bg-cream" data-id="element-181">
      <div className="max-w-4xl mx-auto" data-id="element-182">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="space-y-12" data-id="element-183">
          <motion.div variants={itemVariants} className="text-center space-y-4" data-id="element-184">
            <h2 className="text-3xl md:text-4xl font-bold text-purple-dark" data-id="element-185">
              El problema que te mantiene despierta
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-186" />
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-187">
            <motion.div variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-sm border border-purple/10 flex flex-col items-center text-center space-y-4" data-id="element-188">
              <div className="w-12 h-12 bg-purple/10 rounded-full flex items-center justify-center text-purple" data-id="element-189">
                <DollarSignIcon className="w-6 h-6" data-id="element-190" />
              </div>
              <h3 className="font-bold text-xl text-charcoal" data-id="element-191">
                La Brecha Salarial
              </h3>
              <p className="text-charcoal/80" data-id="element-192">
                Mujeres latinas como tú ganan{' '}
                <strong className="text-danger" data-id="element-193">57 centavos</strong> por cada
                dólar de un hombre blanco. Ingresos irregulares de trabajos gig
                y renta alta en USA.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-sm border border-purple/10 flex flex-col items-center text-center space-y-4" data-id="element-194">
              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold-dark" data-id="element-195">
                <AlertTriangleIcon className="w-6 h-6" data-id="element-196" />
              </div>
              <h3 className="font-bold text-xl text-charcoal" data-id="element-197">
                Gastos Ocultos
              </h3>
              <p className="text-charcoal/80" data-id="element-198">
                Remesas a la familia, comidas para hijos... todo suma. La
                tarjeta al límite con{' '}
                <strong className="text-danger" data-id="element-199">24% de interés</strong> y el
                auto que falla.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-sm border border-purple/10 flex flex-col items-center text-center space-y-4" data-id="element-200">
              <div className="w-12 h-12 bg-purple/10 rounded-full flex items-center justify-center text-purple" data-id="element-201">
                <MoonIcon className="w-6 h-6" data-id="element-202" />
              </div>
              <h3 className="font-bold text-xl text-charcoal" data-id="element-203">
                Ansiedad Nocturna
              </h3>
              <p className="text-charcoal/80" data-id="element-204">
                Intentas presupuestar mentalmente, pero a las 11 PM el pánico
                gana. No es falta de disciplina, faltan herramientas reales.
              </p>
            </motion.div>
          </div>

          <motion.div variants={itemVariants} className="bg-purple-dark text-white p-8 rounded-2xl text-center relative overflow-hidden" data-id="element-205">
            <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-206" />
            <p className="relative z-10 text-xl md:text-2xl font-heading italic" data-id="element-207">
              Revisas apps genéricas en inglés que no entienden tu realidad:{' '}
              <br data-id="element-208" />
              <span className="text-gold" data-id="element-209">
                "¿Café $5? Eso es lujo, yo busco arroz en Aldi."
              </span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}